import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { useNotification } from '../../contexts/NotificationContext';

type ExportType = 'users' | 'subscriptions' | 'audit-logs';

export default function AdminExportPage() {
  const { notifySuccess, notifyError } = useNotification();

  const exportCSV = async (type: ExportType) => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
      
      const res = await fetch(`${backendUrl}/admin/export/${type}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!res.ok) {
        notifyError(`Failed to export ${type}`);
        return;
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${type}.csv`;
      a.click();
      notifySuccess(`${type} CSV downloaded successfully!`);
    } catch (err) {
      console.error('Export error:', err);
      notifyError('Unexpected error during export');
    }
  };

  return (
    <AdminLayout>
      <div className="p-4">
        <h1 className="text-xl font-bold mb-4">📤 Export Data</h1>
        <div className="flex flex-wrap gap-4 mb-4">
          <button
            onClick={() => exportCSV('users')}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Export Users CSV
          </button>
          <button
            className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 opacity-50 cursor-not-allowed"
            disabled
          >
            Export Subscriptions CSV (Coming Soon)
          </button>
          <button
            onClick={() => exportCSV('audit-logs')}
            className="bg-gray-800 text-white px-4 py-2 rounded hover:bg-gray-900"
          >
            Export Audit Logs CSV
          </button>
        </div>
        <p className="text-sm text-gray-500">
          Click a button to download the CSV file.
        </p>
      </div>
    </AdminLayout>
  );
}